import { IAppointmentType } from './appointment-type.interface';
export interface IBonusChart {
    appointmentTypeId:number;
    appointmentType:IAppointmentType;
    l1Percent:number;
}
